module.exports = __webpack_public_path__ + "img/pos_nhap_kiem.2eee3e6b.png";